<template>
    <div>
        <el-form-item label="Treść" required
                      :error="errors[addLanguageSuffix('content')]">
            <el-input v-model="form[addLanguageSuffix('content')]"
                      type="textarea"/>
        </el-form-item>
    </div>
</template>
<script>
    export default {
        props: ['form', 'errors']
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// HTMLWidget.vue?49443309